import { render, staticRenderFns } from "./solutionSRM.vue?vue&type=template&id=55018268&scoped=true"
import script from "./solutionSRM.vue?vue&type=script&lang=js"
export * from "./solutionSRM.vue?vue&type=script&lang=js"
import style0 from "./solutionSRM.vue?vue&type=style&index=0&id=55018268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55018268",
  null
  
)

export default component.exports